import { createSelector } from 'reselect'

const getSubSequenceId = (state, props) => props.subSequence.id;
const getSelectedRows = (state, props) => state.arrangement.selectedRows;
export const getIsSelected = createSelector(
    [getSubSequenceId, getSelectedRows],
    (subSequenceId, selectedRows) => selectedRows.indexOf(subSequenceId) > -1
    );

